import { FC } from "react";

import { Textbox } from "capitalrx-components-2.0/lib/forms";
import { Grid, Stack, useResponsive } from "capitalrx-components-2.0/lib/layout";
import { Body, Heading, Subheading } from "capitalrx-components-2.0/lib/typography";


import { PROVIDER_MANAGEMENT_LAYOUT } from "@/constants";

export interface FieldsTracnsactionValidationProps {
  readonly readOnly: boolean;
}

export const FieldsTransactionValidation: FC<FieldsTracnsactionValidationProps> = ({ readOnly }) => {
  const { sixFull, twelve } = useResponsive(PROVIDER_MANAGEMENT_LAYOUT);

  return (
    <Stack>
      <Heading>Transaction Validation</Heading>
      <Body>For faster approval, include details of previous claims paid by Capital Rx</Body>
      <Grid>
        <Grid.Spread columns={twelve}>
          <Subheading>Claim 1</Subheading>
        </Grid.Spread>
        <Grid.Spread columns={sixFull}>
          <Textbox.Field name="transaction_validation_claim_1_number" label="Claim Number" readOnly={readOnly} />
        </Grid.Spread>
        <Grid.Spread columns={sixFull}>
          <Textbox.Field name="transaction_validation_claim_1_paid_amount" label="Paid Amount" prefix="$" readOnly={readOnly} />
        </Grid.Spread>
        <Grid.Spread columns={twelve}>
          <Subheading>Claim 2</Subheading>
        </Grid.Spread>
        <Grid.Spread columns={sixFull}>
          <Textbox.Field name="transaction_validation_claim_2_number" label="Claim Number" readOnly={readOnly} />
        </Grid.Spread>
        <Grid.Spread columns={sixFull}>
          <Textbox.Field name="transaction_validation_claim_2_paid_amount" label="Paid Amount" prefix="$" readOnly={readOnly} />
        </Grid.Spread>
      </Grid>
    </Stack>
  );
};
